import { getCookie } from '../../../../utils/getCookie';

export const useIsAuthorized = () => Boolean(getCookie('direct_access_token'));
